<div
  #footerContainer
  class="footer-container classification-footer-container"
  [ngClass]="menu | productMenuBasicMethod: 'getFooterWrapperClass'"
  [class.no-classifications]="!(hasClassifications$ | async)"
  [style.display]="!(hasClassifications$ | async) ? 'block' : null"
  [style.color]="menu | method: 'getSectionBodyTextColor' : null">
  <div *ngIf="hasClassifications$ | async" class="footer-classification-board">
    <div
      *ngFor="let classification of uniqueClassifications$ | async; trackBy: trackByClassification"
      class="classification-mapping">
      <div [ngClass]="classification | lowercase">
        {{ classification | getClassificationSymbol }}
      </div>
      <div class="classification-name">
        {{ classification }}
      </div>
    </div>
  </div>
</div>
